import { Button, Container, generateUtilityClasses, Grid, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { UspReportPaymentDetailsResult, UspReportPaymentResult } from '../../../../../models'
import { styled } from '@mui/system'
import { ReactComponent as PrintIcon } from '../../../../../assets/icons/printer.svg'
import { ReactComponent as DownloadIcon } from '../../../../../assets/icons/download_icon.svg'
import { ReactComponent as FilterIcon } from '../../../../../assets/icons/filter_icon.svg'
import { formatNumber, parseToNumber } from '../../../../../utils/general'
import * as XLSX from 'xlsx'
import { convertDateToDisplay } from '../../../../../utils/dateUtils'

const classes = generateUtilityClasses('Container', ['root', 'titleWrap', 'btnWrap'])

const StyledContainer = styled(Container)(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(1, 3, 1, 3),
    margin: 0,
    display: 'flex',
    backgroundColor: theme.palette.background.main,
    width: '100%',
    maxWidth: 'unset',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  [`& .${classes.titleWrap}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  [`& .${classes.btnWrap}`]: {
    maxWidth: '30px',
    maxHeight: '42px',
    minWidth: '30px',
    minHeight: '42px',
    padding: '3px',
    marginLeft: '10px',
    color: theme.palette.text.primary,
  },
}))

interface Props {
  handleOpenFilterModal: () => void
  filterData: UspReportPaymentResult[]
}

const Header = ({ handleOpenFilterModal, filterData }: Props) => {
  const transformDataForExport = (data: UspReportPaymentDetailsResult[]) => {
    return data?.map((item: UspReportPaymentDetailsResult) => ({
      AppliedAmount: item.AppliedAmount,
      CPI1: item.CPI1,
      CPI2: item.CPI2,
      ChargebackCollected: item.ChargebackCollected,
      Date: convertDateToDisplay(item.Date),
      DiscountEarned: item.DiscountEarned,
      DistributionType: item.DistributionType,
      Form: item.Form,
      InsuranceRebate: item.InsuranceRebate,
      InterestCollected: item.InterestCollected,
      InterestRebate: item.InterestRebate,
      LateChargeCollected: item.LateChargeCollected,
      Branch: item.Branch,
      Receipt: item.Receipt,
      Payee: item.Payee,
      StockNumber: item.StockNumber,
      Principal: item.Principal,
      Method: item.Method,
      SalesTax: formatNumber(item.SalesTax),
      Transaction: item.Transaction,
    }))
  }

  const setColumnWidths = (worksheet: any) => {
    const columnWidths = Array(16).fill({ width: 20 })
    worksheet['!cols'] = columnWidths
  }

  const exportToExcel = (data: any, fileName: any) => {
    const transformedData = transformDataForExport(data)
    const worksheet = XLSX.utils.json_to_sheet(transformedData)
    setColumnWidths(worksheet)

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
    XLSX.writeFile(workbook, `${fileName}.xlsx`)
  }

  return (
    <>
      <Grid container justifyContent={'flex-end'} p={3} alignItems={'center'}>
        <Grid item>
          <Tooltip title='Download'>
            <Button variant='text' className={classes.btnWrap} onClick={() => exportToExcel(filterData, 'Accounts Payments Details')}>
              <DownloadIcon />
            </Button>
          </Tooltip>
        </Grid>
        <Grid item>
          <Tooltip title='Print'>
            <Button variant='text' className={classes.btnWrap}>
              <PrintIcon />
            </Button>
          </Tooltip>
        </Grid>
        <Grid item>
          <Tooltip title='Filter'>
            <Button onClick={handleOpenFilterModal} variant='text' className={classes.btnWrap}>
              <FilterIcon />
            </Button>
          </Tooltip>
        </Grid>
      </Grid>
    </>
  )
}

export default Header
